<template>
    <modal  v-model="fade" :title="title"  class-name="vertical-center-modal" width="360" :mask-closable="maskClosable" @on-ok="ok" @on-cancel="cancel" @on-visible-change="changeModal">
        <div class="content-text">{{contentText}}</div>
        <slot></slot>
    </modal>
</template>

<script>
    export default {
        props:{
            maskClosable:{
                type:Boolean,
                default:true
            },
            title:{
                type:String,
                default:'弹框'
            },
            contentText:{
                type:String,
                default:''
            },
        },
        data:()=>{
            return{
                fade:false
            }
        },
        computed: {
        },
        methods:{
            ok () {
                this.$emit('ok')
            },
            changeModal(data){
                console.log(data)
                if(!data){
                    this.hide()
                }
            },
            hide() {
                this.fade = false
            },
            open() {
                this.fade = true;
            },
            cancel () {
                this.$emit('cancel')
            },
        }
    }
</script>

<style scoped lang="scss">
    .content-text{
        font-size: 20px;
        text-align: center;
    }
</style>